export default __webpack_public_path__ + "static/6-a232e99a4b46281679a7bfd8002b48a8.png";